import { ITypedReduxAction } from './actionType';
import { IGetArticleResponse } from '../../repositories/valuation-b2b/v1/get-article';
import { actionTypes } from '../../constants/actionTypes';

const {
  GET_PUBLICATION_REQUEST: REQUEST,
  GET_PUBLICATION_SUCCESS: SUCCESS,
  GET_PUBLICATION_FAILURE: FAILURE,
} = actionTypes;

export interface IGetPublicationParams {
  articleId: number;
}

export interface IGetPublicationSuccessPayload {
  data: IGetArticleResponse;
  articleId: number;
}

type requestAction = ITypedReduxAction<typeof REQUEST, void>;
type successAction = ITypedReduxAction<typeof SUCCESS, IGetPublicationSuccessPayload>;
type failureAction = ITypedReduxAction<typeof FAILURE, void>;

export type TGetPublicationActions = requestAction | successAction | failureAction;

// export interface IPublications {
//   isFetching?: boolean;
//   isError: boolean;
//   data: IGetArticleResponse | null;
// }
